import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('tga_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedMember = localStorage.getItem('tga_member');
    if (storedMember && token) {
      setMember(JSON.parse(storedMember));
    }
    setLoading(false);
  }, [token]);

  const register = async (name, email, password, referralCode) => {
    const payload = { name, email, password };
    if (referralCode) payload.referral_code = referralCode;
    
    const response = await axios.post(`${API_URL}/members/register`, payload);
    
    const { access_token, member: memberData } = response.data;
    
    localStorage.setItem('tga_token', access_token);
    localStorage.setItem('tga_member', JSON.stringify(memberData));
    
    setToken(access_token);
    setMember(memberData);
    
    return memberData;
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API_URL}/members/login`, {
      email,
      password
    });
    
    const { access_token, member: memberData } = response.data;
    
    localStorage.setItem('tga_token', access_token);
    localStorage.setItem('tga_member', JSON.stringify(memberData));
    
    setToken(access_token);
    setMember(memberData);
    
    return memberData;
  };

  const logout = () => {
    localStorage.removeItem('tga_token');
    localStorage.removeItem('tga_member');
    setToken(null);
    setMember(null);
  };

  const refreshMember = async () => {
    if (member?.id) {
      try {
        const response = await axios.get(`${API_URL}/members/${member.id}`);
        const updatedMember = response.data;
        localStorage.setItem('tga_member', JSON.stringify(updatedMember));
        setMember(updatedMember);
        return updatedMember;
      } catch (error) {
        console.error('Failed to refresh member data:', error);
        return null;
      }
    }
    return null;
  };

  const updateMember = (updates) => {
    const updatedMember = { ...member, ...updates };
    localStorage.setItem('tga_member', JSON.stringify(updatedMember));
    setMember(updatedMember);
  };

  const setAuth = (memberData, accessToken) => {
    localStorage.setItem('tga_token', accessToken);
    localStorage.setItem('tga_member', JSON.stringify(memberData));
    setToken(accessToken);
    setMember(memberData);
  };

  return (
    <AuthContext.Provider value={{
      member,
      token,
      loading,
      register,
      login,
      logout,
      refreshMember,
      updateMember,
      setAuth
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
